import { render, staticRenderFns } from "./MultiPanelSidebar.vue?vue&type=template&id=d8f399b8&"
import script from "./MultiPanelSidebar.vue?vue&type=script&lang=js&"
export * from "./MultiPanelSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MultiPanelSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
